export default "__VITE_ASSET__64f6a914__$_?nuxt_component=async&nuxt_component_name=SvgoFilmReview__"